import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";


const AgendaSites = () => {
    const navigate = useNavigate();
    return (
    
       <div class="container text-center mainContent" >
    
       <iframe src=" https://trn.municipiopilar.app/?agendaid=1070&branchid=718&turnero=antecedentes&nombre=Marta&apellido=Velozo&dni=13214508&celular=1162175573&email=marianosebastianoviedo@hotmail.com&idturno=61184 " frameborder="0"  width="100%" height="80%"></iframe>
       
        
    </div>

    );
    }
export default AgendaSites;